
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33634',
  depVersions: {
  "documents-public-ui": "static-1.33634",
  "client-types": "static-1.437",
  "documents-lib": "static-1.33639",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1790",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4702",
  "highcharts": "static-8.97",
  "hs-promise-utils": "static-1.5262",
  "hs-test-utils": "static-1.7655",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11091",
  "I18n": "static-7.1535",
  "jasmine-immutable": "static-1.2683",
  "jasmine-runner": "static-1.6125",
  "lodash": "static-1.3",
  "quartz": "static-1.6539",
  "react": "static-7.174",
  "react-dlb": "static-1.68",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.65",
  "react-rhumb": "static-1.16299",
  "reporting-data": "static-1.65948",
  "reporting-testing-lib": "static-1.7882",
  "reporting-visualizations": "static-1.58025",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4416",
  "webpack-env": "static-1.54",
  "atom": "static-1.4745",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2133",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90847",
  "cssUtils": "static-1.691",
  "customer-data-filters-ui": "static-1.38418",
  "customer-data-objects": "static-1.7283",
  "customer-data-property-utils": "static-1.7737",
  "data-fetching-client": "static-1.9346",
  "enviro": "static-4.371",
  "FireAlarmUi": "static-1.4208",
  "flux-actions": "static-1.294",
  "FormsCommonComponents": "static-1.84892",
  "FormUrlGenerator": "static-2.4404",
  "foundations-components": "static-1.7241",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3825",
  "HubStyle": "static-2.11399",
  "icons": "static-2.608",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6812",
  "metrics-js": "static-1.9296",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.334",
  "property-description-translator": "static-1.3532",
  "property-translator": "static-1.5086",
  "quartz-config": "static-1.317",
  "quartz-core": "static-1.5758",
  "quick-fetch": "static-1.3610",
  "raven": "static-3.5564",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5060",
  "react-virtualized": "static-2.92",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7831",
  "reference-resolvers-lite": "static-1.7763",
  "report-customization-components": "static-1.12157",
  "reporting-enablement": "static-1.21637",
  "reporting-reports": "static-1.65627",
  "reporting-snowflake": "static-1.54567",
  "reporting-ui-components": "static-2.63221",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4275",
  "sales-content-partitioning": "static-1.8607",
  "SalesContentIndexUI": "static-3.8704",
  "sanitize": "static-1.4148",
  "sanitize-text": "static-1.7813",
  "self-service-api": "static-1.9897",
  "SharedI18nStrings": "static-1.179",
  "SharedLegalStrings": "static-1.1451",
  "signup-constants": "static-1.18126",
  "signup-ui-lego-core": "static-1.20136",
  "signup-ui-url-generator": "static-2.7711",
  "styled-components": "static-2.83",
  "StyleGuideUI": "static-3.481",
  "superstore": "static-1.4440",
  "transmute": "static-2.77",
  "ui-addon-form-validation": "static-1.10669",
  "ui-addon-i18n": "static-1.10797",
  "ui-addon-react-router-dom": "static-1.9214",
  "ui-addon-upgrades": "static-9.17376",
  "ui-asset-management-lib": "static-1.10518",
  "ui-images": "static-2.1051",
  "UIComponents": "static-3.8038",
  "usage-tracker": "static-1.7008",
  "usage-tracker-container": "static-1.6998",
  "usage-tracker-core": "static-1.6858",
  "usage-tracker-public": "static-1.6819",
  "viral-links-lib": "static-1.6685",
  "hs-promise-rejection-tracking": "static-1.5234",
  "raven-hubspot": "static-1.5871",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3107",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2816",
  "quartz-webpack": "static-1.2763",
  "ai-components-ui-library": "static-1.8011",
  "amplitude-session-replay-browser": "static-1.53",
  "foundations-assets": "static-1.4503",
  "foundations-theming": "static-1.4074",
  "react-transition-group": "static-1.7",
  "usage-tracker-session-replay": "static-1.4694",
  "foundations-theming-base": "static-1.3059",
  "HeadJS": "static-2.685",
  "framer-motion": "static-1.63",
  "hs-test-utils-bend-plugin": "static-1.2766",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "jasmine": "static-4.4006",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7595",
  "graphql": "static-1.75",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3340",
  "persist-promise": "static-1.3356",
  "reporting-client-types": "static-1.2349",
  "hs-story-utils": "static-1.9102",
  "react-flip-move": "static-1.63",
  "hub-http-shared-msw-handlers": "static-1.9145",
  "hubspotter-http": "static-1.4359",
  "sassPrefix": "static-1.149",
  "conversations-skeleton-state": "static-1.6924",
  "crm-message-bus": "static-1.41992",
  "customer-data-filters-ui-msw-helpers": "static-1.20852",
  "customer-data-objects-ui-components": "static-1.12672",
  "customer-data-reference-ui-components": "static-1.12797",
  "customer-data-ui-utilities": "static-1.9495",
  "framework-builder-read-service-client": "static-1.3728",
  "framework-data-schema-quick-fetch": "static-1.6441",
  "framework-data-schema-resolvers": "static-1.6536",
  "inbound-db-properties-service-client": "static-1.3559",
  "multi-account-reference-resolvers": "static-1.635",
  "onboarding-tours": "static-1.16087",
  "reporting-datasets-permissions-lib": "static-1.12625",
  "ui-addon-teams": "static-1.21043",
  "apollo-stack-hubspot": "static-3.79",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67199",
  "customer-data-properties": "static-1.50395",
  "forms-ai-lib": "static-1.3787",
  "forms-utils-lib": "static-1.11920",
  "foundations-components-test-utils": "static-1.4724",
  "react-dnd-compat": "static-1.4297",
  "react-tinymce": "static-1.54267",
  "tinymce-config": "static-2.53393",
  "ui-gdpr-components": "static-1.10018",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3510",
  "floating-ui": "static-1.49",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.927",
  "ui-fonts": "static-1.353",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.765",
  "mobile-manifest-mixins": "static-1.458",
  "quartz-auth": "static-1.214",
  "quartz-head": "static-1.204",
  "quartz-i18n": "static-1.214",
  "quartz-test": "static-1.214",
  "batch-promise": "static-1.1199",
  "external-options-client-types": "static-1.3864",
  "react-colorpicker": "static-2.9886",
  "reporting-insights-lib": "static-1.787",
  "copilot-toolkit": "static-1.10204",
  "data-quality-ui-library": "static-1.12029",
  "html-to-image": "static-1.47",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40358",
  "reporting-plugins": "static-1.9808",
  "ui-addon-draggable-compat": "static-2.3927",
  "ui-addon-opt": "static-4.8062",
  "ui-shepherd-react": "static-3.9812",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24354",
  "hubspot-apollo-client": "static-1.4553",
  "sales-templates-service-types-lib": "static-1.3875",
  "ui-business-units-lib": "static-1.8680",
  "merchandise-lib": "static-1.253",
  "emoji-regex": "static-1.7",
  "feature-store-service-types": "static-1.4201",
  "purchase-motions-components": "static-1.5291",
  "salesImages": "static-1.518",
  "ts-schema": "static-1.3785",
  "upgrade-management-service-types": "static-1.4192",
  "timezone-utils": "static-2.4917",
  "bender-build-tools": "static-1.2779",
  "chatspot-core": "static-1.19823",
  "bend-plugin-foundations-theming": "static-1.2557",
  "stylex": "static-1.25",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3503",
  "crm-pipelines-api-client-types": "static-1.3846",
  "multi-currency-client-types": "static-1.3403",
  "getting-started-shared-tasks": "static-1.17494",
  "growth-data-modal": "static-1.5002",
  "growth-onboarding-confetti": "static-1.2724",
  "growth-onboarding-next-action-utils": "static-1.1162",
  "navigation-components": "static-1.16895",
  "onboarding-tours-client": "static-1.4301",
  "onboarding-tours-utils": "static-1.153",
  "ui-shepherd-tracker": "static-1.7193",
  "ui-universal-auth": "static-1.8512",
  "user-context": "static-1.4760",
  "cms-field-types": "static-1.4475",
  "content-icons-ui": "static-1.2107",
  "integrations-lib": "static-1.14999",
  "calling-global-api": "static-1.63208",
  "calling-internal-common": "static-1.30960",
  "calling-lifecycle-internal": "static-1.64590",
  "calling-lifecycle-messages": "static-1.56884",
  "commerce-products-lib": "static-1.8455",
  "crm-links": "static-1.5916",
  "file-manager-components": "static-1.22508",
  "google-libphonenumber": "static-1.31",
  "hs-entities": "static-1.321",
  "inbounddb-objects-service-types": "static-1.3931",
  "meetings-icalendar-utils-lib": "static-1.306",
  "object-builder-ui-client": "static-1.47540",
  "pipeline-validation-client-types": "static-1.3667",
  "property-value-citations": "static-1.1009",
  "pulse": "static-1.154",
  "smart-property-lib": "static-1.5414",
  "tiered-pricing": "static-1.624",
  "ui-addon-iframeable": "static-1.8678",
  "final-form": "static-1.63",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19245",
  "tinymce-themes": "static-1.55363",
  "data-token-picker": "static-1.15835",
  "hub-http-contrib": "static-1.2720",
  "interframe": "static-3.4461",
  "tinymce-data": "static-1.39478",
  "tinymce-plugins": "static-1.56507",
  "ui-addon-sales-email": "static-1.4887",
  "hubspotter-http-shared-msw-handlers": "static-1.9143",
  "magpie-lib": "static-1.5246",
  "magpie-types": "static-1.4706",
  "simple-logging-lib": "static-1.2723",
  "content-assistance-lib": "static-1.7260",
  "dashboard-lib": "static-1.80114",
  "ExportDialog": "static-6.10059",
  "hubspot-prosemirror": "static-1.17255",
  "hubspot-prosemirror-plugins": "static-1.17247",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8360",
  "campaign-roi-lib": "static-1.7893",
  "feedback-loader": "static-1.28632",
  "commerce-analytics-service-client": "static-1.3354",
  "onboarding-scopes": "static-1.6114",
  "apollo-link-hub-http": "static-2.4321",
  "hubspot-apollo-cache": "static-1.12",
  "growth-monetization-service-types": "static-1.4208",
  "nav-client-types": "static-1.2005",
  "purchase-motions-api": "static-1.5294",
  "trials-service-types": "static-1.3609",
  "chatspot-client-types": "static-1.10310",
  "idb-keyval": "static-1.37",
  "reactive-lib": "static-1.399",
  "getting-started-shared-tasks-store": "static-1.16612",
  "integrations-error-boundary-lib": "static-1.12414",
  "integrations-tracking-lib": "static-1.5256",
  "native-integrations-shared-strings": "static-1.7459",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10047",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.30966",
  "shared-worker-versioning": "static-1.10690",
  "calling-usage-tracker": "static-1.6211",
  "calling-orchestration-shared-library": "static-1.34397",
  "customer-data-tracking": "static-1.6533",
  "products-iframe-lib": "static-1.7007",
  "products-ui-components-shared-msw-handlers": "static-1.9527",
  "location-customization-utils-lib": "static-1.8138",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3828",
  "video-components-external": "static-1.10166",
  "video-data-lib": "static-1.33824",
  "directed-graph": "static-1.607",
  "event-emitter": "static-1.598",
  "breeze-intelligence-kit": "static-1.5132",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9228",
  "fsm": "static-1.3403",
  "policy-lib": "static-1.6474",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9291",
  "navigation-messaging": "static-1.6222",
  "FileManagerLib": "static-1.38148",
  "NamespacedHubStyle": "static-2.8783",
  "FileManagerCore": "static-1.38007",
  "codemirror": "static-5.88",
  "layout-dnd-components": "static-1.11811",
  "layout-dnd-utils": "static-1.10786",
  "react-codemirror": "static-1.10275",
  "ui-addon-emoji-picker": "static-1.9563",
  "ui-brand-identity-lib": "static-1.13338",
  "ui-addon-video-player": "static-1.8394",
  "ui-coaching-tips": "static-1.27580",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8266",
  "payment-link-components": "static-1.22580",
  "EmailSignatureEditor": "static-1.23693",
  "eligibility-engine-service-types": "static-1.2890",
  "universal-page-editor-lib": "static-1.2669",
  "calling-orchestration-schema": "static-1.34622",
  "sales-views-client-types": "static-1.3965",
  "crm-record-cards-service-types": "static-1.3340",
  "content-media-composition-data-lib": "static-1.10900",
  "content-media-compositions": "static-2.14907",
  "media-bridge-lib": "static-1.18360",
  "trellis-story-utils": "static-1.4196",
  "storybook-react": "static-1.26",
  "audio-components": "static-1.5428",
  "FileManagerImages": "static-1.35659",
  "video-components": "static-1.12169",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4197",
  "video-embed": "static-1.34658",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67274",
  "layout-data-lib": "static-1.9111",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6259",
  "commerce-tours-lib": "static-1.5520",
  "growth-onboarding-reliability": "static-1.4761",
  "sales-checkout-service-client": "static-1.3366",
  "draft-convert": "static-2.31",
  "draft-extend": "static-2.46",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21084",
  "sales-email-signature-service-client": "static-1.3511",
  "hls.js": "static-1.32",
  "social-insights-client-types": "static-1.21049",
  "outpost": "static-1.3887",
  "advanced-menus-core": "static-1.14611",
  "advanced-menus-lib": "static-1.11610",
  "ui-memberships-settings-lib": "static-1.33070",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14610",
  "simple-menus-lib": "static-1.16127"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33634",
  "client-types": "/client-types/static-1.437",
  "documents-lib": "/documents-lib/static-1.33639",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1790",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4702",
  "highcharts": "/highcharts/static-8.97",
  "hs-promise-utils": "/hs-promise-utils/static-1.5262",
  "hs-test-utils": "/hs-test-utils/static-1.7655",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11091",
  "I18n": "/I18n/static-7.1535",
  "jasmine-immutable": "/jasmine-immutable/static-1.2683",
  "jasmine-runner": "/jasmine-runner/static-1.6125",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6539",
  "react": "/react/static-7.174",
  "react-dlb": "/react-dlb/static-1.68",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.65",
  "react-rhumb": "/react-rhumb/static-1.16299",
  "reporting-data": "/reporting-data/static-1.65948",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.7882",
  "reporting-visualizations": "/reporting-visualizations/static-1.58025",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4416",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4745",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2133",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90847",
  "cssUtils": "/cssUtils/static-1.691",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38418",
  "customer-data-objects": "/customer-data-objects/static-1.7283",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7737",
  "data-fetching-client": "/data-fetching-client/static-1.9346",
  "enviro": "/enviro/static-4.371",
  "FireAlarmUi": "/FireAlarmUi/static-1.4208",
  "flux-actions": "/flux-actions/static-1.294",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.84892",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4404",
  "foundations-components": "/foundations-components/static-1.7241",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "HubStyle": "/HubStyle/static-2.11399",
  "icons": "/icons/static-2.608",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6812",
  "metrics-js": "/metrics-js/static-1.9296",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "property-description-translator": "/property-description-translator/static-1.3532",
  "property-translator": "/property-translator/static-1.5086",
  "quartz-config": "/quartz-config/static-1.317",
  "quartz-core": "/quartz-core/static-1.5758",
  "quick-fetch": "/quick-fetch/static-1.3610",
  "raven": "/raven/static-3.5564",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5060",
  "react-virtualized": "/react-virtualized/static-2.92",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7831",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7763",
  "report-customization-components": "/report-customization-components/static-1.12157",
  "reporting-enablement": "/reporting-enablement/static-1.21637",
  "reporting-reports": "/reporting-reports/static-1.65627",
  "reporting-snowflake": "/reporting-snowflake/static-1.54567",
  "reporting-ui-components": "/reporting-ui-components/static-2.63221",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4275",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8607",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8704",
  "sanitize": "/sanitize/static-1.4148",
  "sanitize-text": "/sanitize-text/static-1.7813",
  "self-service-api": "/self-service-api/static-1.9897",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1451",
  "signup-constants": "/signup-constants/static-1.18126",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20136",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7711",
  "styled-components": "/styled-components/static-2.83",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "superstore": "/superstore/static-1.4440",
  "transmute": "/transmute/static-2.77",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10669",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10797",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9214",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17376",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10518",
  "ui-images": "/ui-images/static-2.1051",
  "UIComponents": "/UIComponents/static-3.8038",
  "usage-tracker": "/usage-tracker/static-1.7008",
  "usage-tracker-container": "/usage-tracker-container/static-1.6998",
  "usage-tracker-core": "/usage-tracker-core/static-1.6858",
  "usage-tracker-public": "/usage-tracker-public/static-1.6819",
  "viral-links-lib": "/viral-links-lib/static-1.6685",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3107",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2816",
  "quartz-webpack": "/quartz-webpack/static-1.2763",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8011",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4503",
  "foundations-theming": "/foundations-theming/static-1.4074",
  "react-transition-group": "/react-transition-group/static-1.7",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4694",
  "foundations-theming-base": "/foundations-theming-base/static-1.3059",
  "HeadJS": "/HeadJS/static-2.685",
  "framer-motion": "/framer-motion/static-1.63",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2766",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "jasmine": "/jasmine/static-4.4006",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7595",
  "graphql": "/graphql/static-1.75",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3340",
  "persist-promise": "/persist-promise/static-1.3356",
  "reporting-client-types": "/reporting-client-types/static-1.2349",
  "hs-story-utils": "/hs-story-utils/static-1.9102",
  "react-flip-move": "/react-flip-move/static-1.63",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9145",
  "hubspotter-http": "/hubspotter-http/static-1.4359",
  "sassPrefix": "/sassPrefix/static-1.149",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6924",
  "crm-message-bus": "/crm-message-bus/static-1.41992",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20852",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12672",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12797",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9495",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3728",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6441",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6536",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3559",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.635",
  "onboarding-tours": "/onboarding-tours/static-1.16087",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12625",
  "ui-addon-teams": "/ui-addon-teams/static-1.21043",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67199",
  "customer-data-properties": "/customer-data-properties/static-1.50395",
  "forms-ai-lib": "/forms-ai-lib/static-1.3787",
  "forms-utils-lib": "/forms-utils-lib/static-1.11920",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4724",
  "react-dnd-compat": "/react-dnd-compat/static-1.4297",
  "react-tinymce": "/react-tinymce/static-1.54267",
  "tinymce-config": "/tinymce-config/static-2.53393",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10018",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3510",
  "floating-ui": "/floating-ui/static-1.49",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.927",
  "ui-fonts": "/ui-fonts/static-1.353",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.765",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.458",
  "quartz-auth": "/quartz-auth/static-1.214",
  "quartz-head": "/quartz-head/static-1.204",
  "quartz-i18n": "/quartz-i18n/static-1.214",
  "quartz-test": "/quartz-test/static-1.214",
  "batch-promise": "/batch-promise/static-1.1199",
  "external-options-client-types": "/external-options-client-types/static-1.3864",
  "react-colorpicker": "/react-colorpicker/static-2.9886",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.787",
  "copilot-toolkit": "/copilot-toolkit/static-1.10204",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12029",
  "html-to-image": "/html-to-image/static-1.47",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40358",
  "reporting-plugins": "/reporting-plugins/static-1.9808",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.3927",
  "ui-addon-opt": "/ui-addon-opt/static-4.8062",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9812",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24354",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4553",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3875",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8680",
  "merchandise-lib": "/merchandise-lib/static-1.253",
  "emoji-regex": "/emoji-regex/static-1.7",
  "feature-store-service-types": "/feature-store-service-types/static-1.4201",
  "purchase-motions-components": "/purchase-motions-components/static-1.5291",
  "salesImages": "/salesImages/static-1.518",
  "ts-schema": "/ts-schema/static-1.3785",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4192",
  "timezone-utils": "/timezone-utils/static-2.4917",
  "bender-build-tools": "/bender-build-tools/static-1.2779",
  "chatspot-core": "/chatspot-core/static-1.19823",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2557",
  "stylex": "/stylex/static-1.25",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3503",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3846",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3403",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17494",
  "growth-data-modal": "/growth-data-modal/static-1.5002",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2724",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1162",
  "navigation-components": "/navigation-components/static-1.16895",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4301",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.153",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7193",
  "ui-universal-auth": "/ui-universal-auth/static-1.8512",
  "user-context": "/user-context/static-1.4760",
  "cms-field-types": "/cms-field-types/static-1.4475",
  "content-icons-ui": "/content-icons-ui/static-1.2107",
  "integrations-lib": "/integrations-lib/static-1.14999",
  "calling-global-api": "/calling-global-api/static-1.63208",
  "calling-internal-common": "/calling-internal-common/static-1.30960",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64590",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56884",
  "commerce-products-lib": "/commerce-products-lib/static-1.8455",
  "crm-links": "/crm-links/static-1.5916",
  "file-manager-components": "/file-manager-components/static-1.22508",
  "google-libphonenumber": "/google-libphonenumber/static-1.31",
  "hs-entities": "/hs-entities/static-1.321",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3931",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.306",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47540",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3667",
  "property-value-citations": "/property-value-citations/static-1.1009",
  "pulse": "/pulse/static-1.154",
  "smart-property-lib": "/smart-property-lib/static-1.5414",
  "tiered-pricing": "/tiered-pricing/static-1.624",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8678",
  "final-form": "/final-form/static-1.63",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19245",
  "tinymce-themes": "/tinymce-themes/static-1.55363",
  "data-token-picker": "/data-token-picker/static-1.15835",
  "hub-http-contrib": "/hub-http-contrib/static-1.2720",
  "interframe": "/interframe/static-3.4461",
  "tinymce-data": "/tinymce-data/static-1.39478",
  "tinymce-plugins": "/tinymce-plugins/static-1.56507",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4887",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9143",
  "magpie-lib": "/magpie-lib/static-1.5246",
  "magpie-types": "/magpie-types/static-1.4706",
  "simple-logging-lib": "/simple-logging-lib/static-1.2723",
  "content-assistance-lib": "/content-assistance-lib/static-1.7260",
  "dashboard-lib": "/dashboard-lib/static-1.80114",
  "ExportDialog": "/ExportDialog/static-6.10059",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17255",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17247",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8360",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.7893",
  "feedback-loader": "/feedback-loader/static-1.28632",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3354",
  "onboarding-scopes": "/onboarding-scopes/static-1.6114",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4321",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.12",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4208",
  "nav-client-types": "/nav-client-types/static-1.2005",
  "purchase-motions-api": "/purchase-motions-api/static-1.5294",
  "trials-service-types": "/trials-service-types/static-1.3609",
  "chatspot-client-types": "/chatspot-client-types/static-1.10310",
  "idb-keyval": "/idb-keyval/static-1.37",
  "reactive-lib": "/reactive-lib/static-1.399",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16612",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12414",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5256",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7459",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10047",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.30966",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10690",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6211",
  "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.34397",
  "customer-data-tracking": "/customer-data-tracking/static-1.6533",
  "products-iframe-lib": "/products-iframe-lib/static-1.7007",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9527",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8138",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3828",
  "video-components-external": "/video-components-external/static-1.10166",
  "video-data-lib": "/video-data-lib/static-1.33824",
  "directed-graph": "/directed-graph/static-1.607",
  "event-emitter": "/event-emitter/static-1.598",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5132",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9228",
  "fsm": "/fsm/static-1.3403",
  "policy-lib": "/policy-lib/static-1.6474",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9291",
  "navigation-messaging": "/navigation-messaging/static-1.6222",
  "FileManagerLib": "/FileManagerLib/static-1.38148",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8783",
  "FileManagerCore": "/FileManagerCore/static-1.38007",
  "codemirror": "/codemirror/static-5.88",
  "layout-dnd-components": "/layout-dnd-components/static-1.11811",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10786",
  "react-codemirror": "/react-codemirror/static-1.10275",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9563",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13338",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8394",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27580",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8266",
  "payment-link-components": "/payment-link-components/static-1.22580",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23693",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2890",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2669",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34622",
  "sales-views-client-types": "/sales-views-client-types/static-1.3965",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3340",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10900",
  "content-media-compositions": "/content-media-compositions/static-2.14907",
  "media-bridge-lib": "/media-bridge-lib/static-1.18360",
  "trellis-story-utils": "/trellis-story-utils/static-1.4196",
  "storybook-react": "/storybook-react/static-1.26",
  "audio-components": "/audio-components/static-1.5428",
  "FileManagerImages": "/FileManagerImages/static-1.35659",
  "video-components": "/video-components/static-1.12169",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4197",
  "video-embed": "/video-embed/static-1.34658",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67274",
  "layout-data-lib": "/layout-data-lib/static-1.9111",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6259",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5520",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4761",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3366",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-2.46",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21084",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3511",
  "hls.js": "/hls.js/static-1.32",
  "social-insights-client-types": "/social-insights-client-types/static-1.21049",
  "outpost": "/outpost/static-1.3887",
  "advanced-menus-core": "/advanced-menus-core/static-1.14611",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11610",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33070",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14610",
  "simple-menus-lib": "/simple-menus-lib/static-1.16127"
}
};
